<template>
  <div>
    <v-data-table
      dense
      item-key="_id"
      class="transparent mt-2"
      :items="dataConfiguration"
      :headers="headers"
      disable-pagination
      hide-default-footer
      :loading="loading"
    >
      <template #loading>
        Loading
      </template>
      <template #item.display="{ item, index }">
        <v-switch
          hide-details
          v-model="item.display"
          @change="ignoreColumn(item, index)"
          label="Hourly/ShiftWise"
          class="my-2"
        ></v-switch>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  name: 'DataConfig',
  data() {
    return {
      loading: false,
      headers: [
        {
          text: this.$t('production.column'),
          value: 'text',
          width: '60%',
        },
        {
          text: '',
          value: 'display',
        },
      ],
    };
  },
  computed: {
    ...mapState('webApp', ['appSchema', 'activeAppId']),
    ...mapState('productionLog', [
      'assetId',
    ]),
    dataConfiguration() {
      let columns = [];
      const schemaDetails = Array.isArray(this.appSchema)
        ? this.appSchema.find((schema) => schema.assetId === this.assetId)
        : null;
      if (schemaDetails && Array.isArray(schemaDetails.productionDataConfig)
        && schemaDetails.productionDataConfig.length) {
        columns = [...schemaDetails.productionDataConfig];
      }
      const rejectiontypeavailable = columns.filter((c) => c.value === 'rejectiontypeshift');
      if (rejectiontypeavailable.length === 0) {
        columns.push({ text: 'Rejection Type', value: 'rejectiontypeshift', display: false });
      }
      return columns;
    },
  },
  methods: {
    ...mapMutations('productionLog', ['setLoading']),
    ...mapActions('webApp', ['getAppSchema', 'updateAppSchema']),
    async ignoreColumn(item, index) {
      const updatedSchema = Array.isArray(this.appSchema)
        ? JSON.parse(JSON.stringify(this.appSchema))
        : [];
      const schemaIndex = updatedSchema.findIndex((schema) => schema.assetId === this.assetId);
      if (schemaIndex === -1) {
        updatedSchema.push({
          assetId: this.assetId,
          productionDataConfig: [],
        });
      } else {
        const schemaDetails = updatedSchema[schemaIndex];
        if (!Array.isArray(schemaDetails.productionDataConfig)) {
          schemaDetails.productionDataConfig = [];
        }
        schemaDetails.productionDataConfig[index] = item;
      }
      if (schemaIndex === -1) {
        updatedSchema[updatedSchema.length - 1].productionDataConfig[index] = item;
      }
      this.setLoading(true);
      try {
        await this.updateAppSchema({ appSchema: updatedSchema, saveForAll: false });
        await this.getAppSchema();
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>
